{
  "post-office.stakeholder-comms-common.email-header.atlassian-logo-alt": [
    {
      "type": 0,
      "value": "Atlassian"
    }
  ],
  "stakeholder-comms-confirm-add-subscriber-email.email-events-list.no-translate": [
    {
      "type": 0,
      "value": "You will now receive emails whenever:"
    }
  ],
  "stakeholder-comms-confirm-add-subscriber-email.endpoint-info.no-translate": [
    {
      "type": 0,
      "value": "View Status page"
    }
  ],
  "stakeholder-comms-confirm-add-subscriber-email.footer-message-url.email.email.no-translate": [
    {
      "type": 0,
      "value": "Privacy Policy"
    }
  ],
  "stakeholder-comms-confirm-add-subscriber-email.footer-message.email.body.no-translate": [
    {
      "type": 0,
      "value": "Sent to you by Atlassian Jira Service Management • "
    }
  ],
  "stakeholder-comms-confirm-add-subscriber-email.list-item.incident-resolved.no-translate": [
    {
      "type": 0,
      "value": "An incident is resolved"
    }
  ],
  "stakeholder-comms-confirm-add-subscriber-email.list-item.service-outage.no-translate": [
    {
      "type": 0,
      "value": "A service outage or degradation occurs"
    }
  ],
  "stakeholder-comms-confirm-add-subscriber-email.message-template.email.subject-generic.no-translate": [
    {
      "type": 0,
      "value": "Added as subscriber to status page updates"
    }
  ],
  "stakeholder-comms-confirm-add-subscriber-email.message-template.email.subject-with-page-name.no-translate": [
    {
      "type": 0,
      "value": "Added as subscriber to "
    },
    {
      "type": 1,
      "value": "pageNameText"
    },
    {
      "type": 0,
      "value": " status updates"
    }
  ],
  "stakeholder-comms-confirm-add-subscriber-email.title-message.email.title.no-translate": [
    {
      "type": 0,
      "value": "You have been added as a subscriber"
    }
  ],
  "stakeholder-comms-confirm-add-subscriber-email.webhook-added.no-translate": [
    {
      "type": 0,
      "value": "The admin has successfully added you as a subscriber to "
    },
    {
      "type": 1,
      "value": "pageNameText"
    },
    {
      "type": 0,
      "value": " status page."
    }
  ],
  "stakeholder-comms-webhook-notification-confirmation-email.endpoint-info-hyperlink.no-translate": [
    {
      "type": 0,
      "value": "Read more about status pages"
    }
  ],
  "stakeholder-comms-webhook-notification-confirmation-email.endpoint-info.no-translate": [
    {
      "type": 0,
      "value": "The endpoint "
    },
    {
      "type": 1,
      "value": "webhookEndpointUrl"
    },
    {
      "type": 0,
      "value": " is now set to receive updates. "
    }
  ],
  "stakeholder-comms-webhook-notification-confirmation-email.footer-message-url.email.email.no-translate": [
    {
      "type": 0,
      "value": "Privacy Policy"
    }
  ],
  "stakeholder-comms-webhook-notification-confirmation-email.footer-message.email.body.no-translate": [
    {
      "type": 0,
      "value": "Sent to you by Atlassian Jira Service Management • "
    }
  ],
  "stakeholder-comms-webhook-notification-confirmation-email.greeting.no-translate": [
    {
      "type": 0,
      "value": "Hi there,"
    }
  ],
  "stakeholder-comms-webhook-notification-confirmation-email.title-message.email.title.no-translate": [
    {
      "type": 0,
      "value": "Webhook subscription activated"
    }
  ],
  "stakeholder-comms-webhook-notification-confirmation-email.webhook-added.no-translate": [
    {
      "type": 0,
      "value": "We've added your webhook subscription for "
    },
    {
      "type": 1,
      "value": "pageNameText"
    },
    {
      "type": 0,
      "value": " status page."
    }
  ],
  "stakeholder-comms-webhook-notification-delivery-failure.deactivation-reason.no-translate": [
    {
      "type": 0,
      "value": " has been deactivated because we couldn't deliver notifications to it. This endpoint was previously reachable, but it's now returning errors or is unreachable."
    }
  ],
  "stakeholder-comms-webhook-notification-delivery-failure.endpoint-deactivated.no-translate": [
    {
      "type": 0,
      "value": "Your endpoint "
    },
    {
      "type": 1,
      "value": "webhookEndpointUrl"
    }
  ],
  "stakeholder-comms-webhook-notification-delivery-failure.endpoint-info-hyperlink.no-translate": [
    {
      "type": 0,
      "value": "Read more about status pages"
    }
  ],
  "stakeholder-comms-webhook-notification-delivery-failure.footer-message-url.email.no-translate": [
    {
      "type": 0,
      "value": "Privacy Policy"
    }
  ],
  "stakeholder-comms-webhook-notification-delivery-failure.footer-message.email.body.no-translate": [
    {
      "type": 0,
      "value": "Sent to you by Atlassian Jira Service Management • "
    }
  ],
  "stakeholder-comms-webhook-notification-delivery-failure.resubscribe-message.no-translate": [
    {
      "type": 0,
      "value": "To continue receiving updates, resubscribe to your endpoint."
    }
  ],
  "stakeholder-comms-webhook-notification-delivery-failure.title-message.email.title.no-translate": [
    {
      "type": 0,
      "value": "Webhook subscription deactivated"
    }
  ],
  "stakeholder-comms-webhook-validation-failure.endpoint-info-hyperlink.no-translate": [
    {
      "type": 0,
      "value": "Read more about status pages"
    }
  ],
  "stakeholder-comms-webhook-validation-failure.endpoint-unreachable.no-translate": [
    {
      "type": 0,
      "value": "The endpoint "
    },
    {
      "type": 1,
      "value": "webhookEndpointUrl"
    },
    {
      "type": 0,
      "value": " could not be reached or did not respond."
    }
  ],
  "stakeholder-comms-webhook-validation-failure.footer-message-url.email.no-translate": [
    {
      "type": 0,
      "value": "Privacy Policy"
    }
  ],
  "stakeholder-comms-webhook-validation-failure.footer-message.email.body.no-translate": [
    {
      "type": 0,
      "value": "Sent to you by Atlassian Jira Service Management • "
    }
  ],
  "stakeholder-comms-webhook-validation-failure.title-message.email.title.no-translate": [
    {
      "type": 0,
      "value": "Endpoint validation failed"
    }
  ],
  "stakeholder-comms-webhook-validation-failure.webhook-validation-error.no-translate": [
    {
      "type": 0,
      "value": "We couldn't notify your webhook for "
    },
    {
      "type": 1,
      "value": "pageNameText"
    },
    {
      "type": 0,
      "value": " status page updates."
    }
  ],
  "status-page.create-component-details.spotlight.got-it": [
    {
      "type": 0,
      "value": "Ok, got it"
    }
  ],
  "status-page.create-component.spotlight.action": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "status-page.create-component.spotlight.primary-action": [
    {
      "type": 0,
      "value": "Next"
    }
  ],
  "status-page.create-component.spotlight.step1.body": [
    {
      "type": 0,
      "value": "Customize each component and link it to a service"
    }
  ],
  "status-page.create-component.spotlight.step1.heading": [
    {
      "type": 0,
      "value": "Add component"
    }
  ],
  "status-page.create-component.spotlight.step2.body": [
    {
      "type": 0,
      "value": "Organize your components by adding them to specific groups."
    }
  ],
  "status-page.create-component.spotlight.step2.heading": [
    {
      "type": 0,
      "value": "Group components"
    }
  ],
  "status-page.create-component.spotlight.step3.body": [
    {
      "type": 0,
      "value": "Add multiple components and groups for better structure and clarity."
    }
  ],
  "status-page.create-component.spotlight.step3.heading": [
    {
      "type": 0,
      "value": "Manage and organize"
    }
  ],
  "status-page.details.actions.spotlight.body": [
    {
      "type": 0,
      "value": "Easily manage your status page, edit details and post updates to keep your audience informed."
    }
  ],
  "status-page.details.actions.spotlight.got-it": [
    {
      "type": 0,
      "value": "Ok, got it"
    }
  ],
  "status-page.details.actions.spotlight.heading": [
    {
      "type": 0,
      "value": "Update and manage"
    }
  ],
  "status-page.details.tabs.spotlight.action": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "status-page.details.tabs.spotlight.body": [
    {
      "type": 0,
      "value": "Review your status page, target audience, and post real-time incident updates, all from a single place."
    }
  ],
  "status-page.details.tabs.spotlight.body.line1": [
    {
      "type": 0,
      "value": "Review your status page, target"
    }
  ],
  "status-page.details.tabs.spotlight.body.line2": [
    {
      "type": 0,
      "value": "audience, and post real-time incident"
    }
  ],
  "status-page.details.tabs.spotlight.body.line3": [
    {
      "type": 0,
      "value": "updates, all from a single place."
    }
  ],
  "status-page.details.tabs.spotlight.heading": [
    {
      "type": 0,
      "value": "All at a glance"
    }
  ],
  "status-page.details.tabs.spotlight.primary-action": [
    {
      "type": 0,
      "value": "Next"
    }
  ],
  "statuspage.actions-spotlight.progress": [
    {
      "type": 1,
      "value": "currentStep"
    },
    {
      "type": 0,
      "value": "/"
    },
    {
      "type": 1,
      "value": "totalSteps"
    }
  ],
  "statuspage.appearance-spotlight.action": [
    {
      "type": 0,
      "value": "Ok, got it"
    }
  ],
  "statuspage.appearance-spotlight.body": [
    {
      "type": 0,
      "value": "Customize with additional flexibility and advanced styling."
    }
  ],
  "statuspage.appearance-spotlight.heading": [
    {
      "type": 0,
      "value": "Switch to CSS view"
    }
  ],
  "statuspage.confirm-incident-notifications.button.verify-email.no-translate": [
    {
      "type": 0,
      "value": "Confirm subscription"
    }
  ],
  "statuspage.confirm-incident-notifications.footer-message-url.email.email.no-translate": [
    {
      "type": 0,
      "value": "Privacy Policy"
    }
  ],
  "statuspage.confirm-incident-notifications.footer-message.email.body.no-translate": [
    {
      "type": 0,
      "value": "Sent to you by Atlassian Jira Service Management • "
    }
  ],
  "statuspage.confirm-incident-notifications.list-item.incident-resolved.no-translate": [
    {
      "type": 0,
      "value": "An incident is resolved"
    }
  ],
  "statuspage.confirm-incident-notifications.list-item.scheduled-maintenance.no-translate": [
    {
      "type": 0,
      "value": "Scheduled maintenance is announced"
    }
  ],
  "statuspage.confirm-incident-notifications.list-item.service-outage.no-translate": [
    {
      "type": 0,
      "value": "A service outage or degradation occurs"
    }
  ],
  "statuspage.confirm-incident-notifications.message-template.email.subject-generic.no-translate": [
    {
      "type": 0,
      "value": "Confirm your email to subscribe to status page updates"
    }
  ],
  "statuspage.confirm-incident-notifications.message-template.email.subject-with-page-name.no-translate": [
    {
      "type": 0,
      "value": "Confirm your email to subscribe to "
    },
    {
      "type": 1,
      "value": "pageName"
    },
    {
      "type": 0,
      "value": " status updates"
    }
  ],
  "statuspage.confirm-incident-notifications.test-message.email.body-hello.no-translate": [
    {
      "type": 0,
      "value": "Hi there,"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "Please confirm your email address to start receiving incident and maintenance notifications."
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "Once confirmed, you’ll receive emails whenever:"
    }
  ],
  "statuspage.confirm-incident-notifications.title-message.email.title.no-translate": [
    {
      "type": 0,
      "value": "Confirm your subscription"
    }
  ],
  "statuspage.create-component-spotlight.progress": [
    {
      "type": 1,
      "value": "currentStep"
    },
    {
      "type": 0,
      "value": "/"
    },
    {
      "type": 1,
      "value": "totalSteps"
    }
  ],
  "statuspage.edit-spotlight.action": [
    {
      "type": 0,
      "value": "Done"
    }
  ],
  "statuspage.edit-spotlight.body": [
    {
      "type": 0,
      "value": "Customize your status page to match your brand. Add the components you need and personalize the look and feel with brand new colours and themes."
    }
  ],
  "statuspage.edit-spotlight.heading": [
    {
      "type": 0,
      "value": "Status page created! Set it up in a few simple steps."
    }
  ],
  "statuspage.navigation-spotlight.action": [
    {
      "type": 0,
      "value": "About status pages"
    }
  ],
  "statuspage.navigation-spotlight.body": [
    {
      "type": 0,
      "value": "Post real-time updates and customize your status pages directly from here, without switching platforms."
    }
  ],
  "statuspage.navigation-spotlight.heading": [
    {
      "type": 0,
      "value": "Create and manage status pages"
    }
  ],
  "statuspage.stakeholder-comms-archive-email.title.no-translate": [
    {
      "type": 0,
      "value": "Your status page is archived and will be deleted in 60 days."
    }
  ],
  "statuspage.stakeholder-comms-archive-page-email.footer-message-url.email.email.no-translate": [
    {
      "type": 0,
      "value": "Privacy Policy"
    }
  ],
  "statuspage.stakeholder-comms-archive-page-email.footer-message.email.body.no-translate": [
    {
      "type": 0,
      "value": "Sent to you by Atlassian Jira Service Management • "
    }
  ],
  "statuspage.stakeholder-comms-archive-page-email.incident-details-message.email.title.no-translate": [
    {
      "type": 0,
      "value": "Details of the status page"
    }
  ],
  "statuspage.stakeholder-comms-archive-page-email.message-template-template.email.body.img.alt.no-translate": [
    {
      "type": 0,
      "value": "Atlassian Logo"
    }
  ],
  "statuspage.stakeholder-comms-archive-page-email.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Status page archived"
    }
  ],
  "statuspage.stakeholder-comms-archive-page-email.test-message.email.hello-message.no-translate": [
    {
      "type": 0,
      "value": "Hi there,"
    }
  ],
  "statuspage.stakeholder-comms-archive-page-email.test-message.email.incident-info-description-title.no-translate": [
    {
      "type": 0,
      "value": "Archived on"
    }
  ],
  "statuspage.stakeholder-comms-archive-page-email.test-message.email.incident-info-details.no-translate": [
    {
      "type": 1,
      "value": "archivedOn"
    }
  ],
  "statuspage.stakeholder-comms-archive-page-email.test-message.email.incident-info-status-title.no-translate": [
    {
      "type": 0,
      "value": "URL"
    }
  ],
  "statuspage.stakeholder-comms-archive-page-email.test-message.email.incident-info-status.no-translate": [
    {
      "type": 1,
      "value": "pageUrl"
    }
  ],
  "statuspage.stakeholder-comms-archive-page-email.test-message.email.incident-info-time-title.no-translate": [
    {
      "type": 0,
      "value": "Permanent deletion date"
    }
  ],
  "statuspage.stakeholder-comms-archive-page-email.test-message.email.incident-info-time.no-translate": [
    {
      "type": 1,
      "value": "deletionDate"
    }
  ],
  "statuspage.stakeholder-comms-archive-page-email.test-message.email.introduction-message.no-translate": [
    {
      "type": 0,
      "value": "We've received your request to archive the status page. This status page will be automatically deleted in 60 days"
    }
  ],
  "statuspage.stakeholder-comms-archive-page-email.test-message.email.post-info-message.no-translate": [
    {
      "type": 0,
      "value": "If you wish to restore it, you can do so within the next 60 days"
    }
  ],
  "statuspage.stakeholder-comms-confirm-webhook-subscription-email.message-template-template.email.body.img.alt.no-translate": [
    {
      "type": 0,
      "value": "Description of image"
    }
  ],
  "statuspage.stakeholder-comms-confirm-webhook-subscription-email.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Post Office Test Message from "
    },
    {
      "type": 1,
      "value": "env"
    }
  ],
  "statuspage.stakeholder-comms-confirm-webhook-subscription-email.test-message.email.body.hello.no-translate": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "statuspage.stakeholder-comms-confirm-webhook-subscription-email.test-message.email.body.no-translate": [
    {
      "type": 0,
      "value": "This is a test message from the "
    },
    {
      "type": 1,
      "value": "env"
    },
    {
      "type": 0,
      "value": " environment."
    }
  ],
  "statuspage.stakeholder-comms-confirm-webhook-subscription-email.test-message.email.body.regards.no-translate": [
    {
      "type": 0,
      "value": "Team Post Office"
    }
  ],
  "statuspage.stakeholder-comms-confirm-webhook-subscription-email.test-message.email.body.signoff.no-translate": [
    {
      "type": 0,
      "value": "Regards,"
    }
  ],
  "statuspage.stakeholder-comms-confirm-webhook-subscription-email.test-message.email.unsubscribe.text.no-translate": [
    {
      "type": 0,
      "value": "Unsubscribe"
    }
  ],
  "statuspage.stakeholder-comms-maintenance-custom-email.message-template-template.email.body.img.alt.no-translate": [
    {
      "type": 0,
      "value": "Description of image"
    }
  ],
  "statuspage.stakeholder-comms-maintenance-custom-email.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Post Office Test Message from "
    },
    {
      "type": 1,
      "value": "env"
    }
  ],
  "statuspage.stakeholder-comms-maintenance-custom-email.test-message.email.body.hello.no-translate": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "statuspage.stakeholder-comms-maintenance-custom-email.test-message.email.body.no-translate": [
    {
      "type": 0,
      "value": "This is a test message from the "
    },
    {
      "type": 1,
      "value": "env"
    },
    {
      "type": 0,
      "value": " environment."
    }
  ],
  "statuspage.stakeholder-comms-maintenance-custom-email.test-message.email.body.regards.no-translate": [
    {
      "type": 0,
      "value": "Team Post Office"
    }
  ],
  "statuspage.stakeholder-comms-maintenance-custom-email.test-message.email.body.signoff.no-translate": [
    {
      "type": 0,
      "value": "Regards,"
    }
  ],
  "statuspage.stakeholder-comms-maintenance-custom-email.test-message.email.unsubscribe.text.no-translate": [
    {
      "type": 0,
      "value": "Unsubscribe"
    }
  ],
  "statuspage.stakeholder-comms-maintenance-notification-email.message-template-template.email.body.img.alt.no-translate": [
    {
      "type": 0,
      "value": "Description of image"
    }
  ],
  "statuspage.stakeholder-comms-maintenance-notification-email.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Post Office Test Message from "
    },
    {
      "type": 1,
      "value": "env"
    }
  ],
  "statuspage.stakeholder-comms-maintenance-notification-email.test-message.email.body.hello.no-translate": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "statuspage.stakeholder-comms-maintenance-notification-email.test-message.email.body.no-translate": [
    {
      "type": 0,
      "value": "This is a test message from the "
    },
    {
      "type": 1,
      "value": "env"
    },
    {
      "type": 0,
      "value": " environment."
    }
  ],
  "statuspage.stakeholder-comms-maintenance-notification-email.test-message.email.body.regards.no-translate": [
    {
      "type": 0,
      "value": "Team Post Office"
    }
  ],
  "statuspage.stakeholder-comms-maintenance-notification-email.test-message.email.body.signoff.no-translate": [
    {
      "type": 0,
      "value": "Regards,"
    }
  ],
  "statuspage.stakeholder-comms-maintenance-notification-email.test-message.email.unsubscribe.text.no-translate": [
    {
      "type": 0,
      "value": "Unsubscribe"
    }
  ],
  "statuspage.stakeholder-comms-page-restored-email.footer-message-url.email.email.no-translate": [
    {
      "type": 0,
      "value": "Privacy Policy"
    }
  ],
  "statuspage.stakeholder-comms-page-restored-email.footer-message.email.body.no-translate": [
    {
      "type": 0,
      "value": "Sent to you by Atlassian Jira Service Management • "
    }
  ],
  "statuspage.stakeholder-comms-page-restored-email.incident-details-message.email.title.no-translate": [
    {
      "type": 0,
      "value": "Details of the status page"
    }
  ],
  "statuspage.stakeholder-comms-page-restored-email.message-template-template.email.body.img.alt.no-translate": [
    {
      "type": 0,
      "value": "Atlassian Logo"
    }
  ],
  "statuspage.stakeholder-comms-page-restored-email.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Status page restored"
    }
  ],
  "statuspage.stakeholder-comms-page-restored-email.test-message.email.hello-message.no-translate": [
    {
      "type": 0,
      "value": "Hi there,"
    }
  ],
  "statuspage.stakeholder-comms-page-restored-email.test-message.email.incident-info-description-title.no-translate": [
    {
      "type": 0,
      "value": "Archived on"
    }
  ],
  "statuspage.stakeholder-comms-page-restored-email.test-message.email.incident-info-details.no-translate": [
    {
      "type": 1,
      "value": "archivedOn"
    }
  ],
  "statuspage.stakeholder-comms-page-restored-email.test-message.email.incident-info-status-title.no-translate": [
    {
      "type": 0,
      "value": "URL"
    }
  ],
  "statuspage.stakeholder-comms-page-restored-email.test-message.email.incident-info-status.no-translate": [
    {
      "type": 1,
      "value": "pageUrl"
    }
  ],
  "statuspage.stakeholder-comms-page-restored-email.test-message.email.introduction-message.no-translate": [
    {
      "type": 0,
      "value": "We've received your request to restore the status page. You can now edit the page and post any updates as needed."
    }
  ],
  "statuspage.stakeholder-comms-page-restored-email.test-message.email.post-info-message.no-translate": [
    {
      "type": 0,
      "value": "You can publish the page when you're ready to make it accessible to all subscribers."
    }
  ],
  "statuspage.stakeholder-comms-page-restored-email.title.no-translate": [
    {
      "type": 0,
      "value": "Your status page has been restored"
    }
  ],
  "statuspage.stakeholder-comms-sender-test.footer-message-url.email.email.no-translate": [
    {
      "type": 0,
      "value": "Privacy Policy"
    }
  ],
  "statuspage.stakeholder-comms-sender-test.footer-message.email.body": [
    {
      "type": 0,
      "value": "Sent to you by Atlassian Jira Service Management • "
    }
  ],
  "statuspage.stakeholder-comms-sender-test.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Post Office Test Message from "
    },
    {
      "type": 1,
      "value": "env"
    }
  ],
  "statuspage.stakeholder-comms-sender-test.test-message.email.body.no-translate": [
    {
      "type": 0,
      "value": "Thanks for subscribing to pageName status updates. You're almost done - we just need to confirm your subscription."
    }
  ],
  "statuspage.stakeholder-comms-sender-test.test-message.email.link-body.no-translate": [
    {
      "type": 0,
      "value": "In order to activate your subscription, please click the following link:"
    }
  ],
  "statuspage.stakeholder-comms-sender-test.title-message.email.title": [
    {
      "type": 0,
      "value": "Confirm your subscription."
    }
  ],
  "statuspage.stakeholder-comms-subscriber-incident-status-email.affected-components.and-more.no-translate": [
    {
      "type": 0,
      "value": " and "
    },
    {
      "type": 1,
      "value": "count"
    },
    {
      "type": 0,
      "value": " more"
    }
  ],
  "statuspage.stakeholder-comms-subscriber-incident-status-email.button.view-status-page.no-translate": [
    {
      "type": 0,
      "value": "View Status page"
    }
  ],
  "statuspage.stakeholder-comms-subscriber-incident-status-email.footer-message-url.email.email.no-translate": [
    {
      "type": 0,
      "value": "Privacy Policy"
    }
  ],
  "statuspage.stakeholder-comms-subscriber-incident-status-email.footer-message.email.body.no-translate": [
    {
      "type": 0,
      "value": "Sent to you by Atlassian Jira Service Management • "
    }
  ],
  "statuspage.stakeholder-comms-subscriber-incident-status-email.footer-unsubscribe-url.email.email.no-translate": [
    {
      "type": 0,
      "value": "Unsubscribe"
    }
  ],
  "statuspage.stakeholder-comms-subscriber-incident-status-email.incident-details-message.email.title.no-translate": [
    {
      "type": 0,
      "value": "Incident details"
    }
  ],
  "statuspage.stakeholder-comms-subscriber-incident-status-email.message-template.email.subject-generic.no-translate": [
    {
      "type": 0,
      "value": "Status page Incident: "
    },
    {
      "type": 1,
      "value": "incidentName"
    },
    {
      "type": 0,
      "value": " ("
    },
    {
      "type": 1,
      "value": "incidentStatus"
    },
    {
      "type": 0,
      "value": ")"
    }
  ],
  "statuspage.stakeholder-comms-subscriber-incident-status-email.message-template.email.subject-with-page-name.no-translate": [
    {
      "type": 1,
      "value": "pageName"
    },
    {
      "type": 0,
      "value": " Incident: "
    },
    {
      "type": 1,
      "value": "incidentName"
    },
    {
      "type": 0,
      "value": " ("
    },
    {
      "type": 1,
      "value": "incidentStatus"
    },
    {
      "type": 0,
      "value": ")"
    }
  ],
  "statuspage.stakeholder-comms-subscriber-incident-status-email.test-message.email.hello-message.no-translate": [
    {
      "type": 0,
      "value": "Hi there,"
    }
  ],
  "statuspage.stakeholder-comms-subscriber-incident-status-email.test-message.email.incident-info-affected-components-title.no-translate": [
    {
      "type": 0,
      "value": "Affected components"
    }
  ],
  "statuspage.stakeholder-comms-subscriber-incident-status-email.test-message.email.incident-info-affected-components.no-translate": [
    {
      "type": 1,
      "value": "affectedComponentsString"
    }
  ],
  "statuspage.stakeholder-comms-subscriber-incident-status-email.test-message.email.incident-info-description-title.no-translate": [
    {
      "type": 0,
      "value": "Details"
    }
  ],
  "statuspage.stakeholder-comms-subscriber-incident-status-email.test-message.email.incident-info-details.no-translate": [
    {
      "type": 1,
      "value": "incidentDescription"
    }
  ],
  "statuspage.stakeholder-comms-subscriber-incident-status-email.test-message.email.incident-info-status-title.no-translate": [
    {
      "type": 0,
      "value": "Status"
    }
  ],
  "statuspage.stakeholder-comms-subscriber-incident-status-email.test-message.email.incident-info-status.no-translate": [
    {
      "type": 1,
      "value": "incidentStatus"
    }
  ],
  "statuspage.stakeholder-comms-subscriber-incident-status-email.test-message.email.incident-info-time-title.no-translate": [
    {
      "type": 0,
      "value": "Time posted"
    }
  ],
  "statuspage.stakeholder-comms-subscriber-incident-status-email.test-message.email.incident-info-time.no-translate": [
    {
      "type": 1,
      "value": "timePosted"
    }
  ],
  "statuspage.stakeholder-comms-subscriber-incident-status-email.test-message.email.introduction-message.no-translate": [
    {
      "type": 0,
      "value": "We're investigating issues reported on the "
    },
    {
      "type": 1,
      "value": "pageNameText"
    },
    {
      "type": 0,
      "value": "status page. Here are the details:"
    }
  ],
  "statuspage.stakeholder-comms-subscriber-incident-status-email.test-message.email.post-info-message.no-translate": [
    {
      "type": 0,
      "value": "You received this email because you subscribed to incident updates for "
    },
    {
      "type": 1,
      "value": "pageNameText"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "statuspage.stakeholder-comms-subscriber-incident-status-email.title-message.email.title.no-translate": [
    {
      "type": 1,
      "value": "incidentName"
    },
    {
      "type": 0,
      "value": " ("
    },
    {
      "type": 1,
      "value": "incidentStatus"
    },
    {
      "type": 0,
      "value": ")"
    }
  ],
  "statuspage.stakeholder-comms-user-added-verify-email.button.verify-email": [
    {
      "type": 0,
      "value": "Verify your email"
    }
  ],
  "statuspage.stakeholder-comms-user-added-verify-email.footer-message-url.email.email.no-translate": [
    {
      "type": 0,
      "value": "Privacy Policy"
    }
  ],
  "statuspage.stakeholder-comms-user-added-verify-email.footer-message.email.body": [
    {
      "type": 0,
      "value": "This email was sent by Atlassian Jira Service Management • "
    }
  ],
  "statuspage.stakeholder-comms-user-added-verify-email.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "[Action required] Verify your email to join "
    },
    {
      "type": 1,
      "value": "siteName"
    },
    {
      "type": 0,
      "value": "'s site as a stakeholder on "
    },
    {
      "type": 1,
      "value": "env"
    }
  ],
  "statuspage.stakeholder-comms-user-added-verify-email.table-message1.email.body": [
    {
      "type": 0,
      "value": "Know about disruptions that affect operations"
    }
  ],
  "statuspage.stakeholder-comms-user-added-verify-email.table-message2.email.body": [
    {
      "type": 0,
      "value": "Make better decisions as you’re always informed"
    }
  ],
  "statuspage.stakeholder-comms-user-added-verify-email.table-message3.email.body": [
    {
      "type": 0,
      "value": "Get notified about the health and status of key services"
    }
  ],
  "statuspage.stakeholder-comms-user-added-verify-email.table-title-message.email.title": [
    {
      "type": 0,
      "value": "Stay in the loop always"
    }
  ],
  "statuspage.stakeholder-comms-user-added-verify-email.test-message.email.body.hello.no-translate": [
    {
      "type": 0,
      "value": "G'day "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "statuspage.stakeholder-comms-user-added-verify-email.test-message.email.body1.no-translate": [
    {
      "type": 1,
      "value": "adminName"
    },
    {
      "type": 0,
      "value": " has invited you to join their Jira Service Management site, "
    },
    {
      "type": 1,
      "value": "siteName"
    },
    {
      "type": 0,
      "value": ", as a stakeholder."
    }
  ],
  "statuspage.stakeholder-comms-user-added-verify-email.test-message.email.body2.no-translate": [
    {
      "type": 0,
      "value": "Once you verify your email, you'll start receiving important notifications about incidents and changes directly to your inbox."
    }
  ],
  "statuspage.stakeholder-comms-user-added-verify-email.test-message.email.body3.no-translate": [
    {
      "type": 0,
      "value": "To receive updates on incidents communications, verify your email now!"
    }
  ],
  "statuspage.stakeholder-comms-user-added-verify-email.title-message.email.title": [
    {
      "type": 0,
      "value": "You’ve been invited to join "
    },
    {
      "type": 1,
      "value": "siteName"
    },
    {
      "type": 0,
      "value": " as a stakeholder"
    }
  ],
  "statuspage.stakeholder-comms-webhook-notification-confirmation-email.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Your webhook subscription is active"
    }
  ],
  "statuspage.stakeholder-comms-webhook-notification-delivery-failure.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Your webhook subscription is deactivated"
    }
  ],
  "statuspage.stakeholder-comms-webhook-validation-failure.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Your webhook subscription could not be activated"
    }
  ],
  "statuspage.statuspage-navigation-spotlight-v2.description.no-translate": [
    {
      "type": 0,
      "value": "Statuspage navigation spotlight v2 test message."
    }
  ],
  "statuspage.statuspage-navigation-spotlight-v2.title.no-translate": [
    {
      "type": 0,
      "value": "This is a Post Office Test Message"
    }
  ],
  "statuspage.statuspage-navigation-spotlight.description.no-translate": [
    {
      "type": 0,
      "value": "Statuspage navigation spotlight test message."
    }
  ],
  "statuspage.statuspage-navigation-spotlight.title.no-translate": [
    {
      "type": 0,
      "value": "This is a Post Office Test Message"
    }
  ]
}